module.exports = __webpack_public_path__ + "img/ol_bg2.27272727.jpg";